import { PaymentMethodEnum } from '@/types/common';
import { StripeGenericPayForm } from './StripeGenericPayForm';

export const CashAppForm = () => {
  return <StripeGenericPayForm paymentMethod={PaymentMethodEnum.CASH_APP} />;
};
